import { useBootstrapLabels } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-labels';
import { Label, LabelType } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

interface UseCurrentLabelsParams {
  type: LabelType;
  currentLabelIds?: string[];
  propsSelectedLabels?: Label[];
}

export function useCurrentLabels({
  type,
  currentLabelIds,
  propsSelectedLabels,
}: UseCurrentLabelsParams): Label[] {
  const { items } = useBootstrapLabels(type);

  // Stable key so same ids (different array ref) doesn't force recompute
  const labelIdsKey = currentLabelIds?.slice().sort().join(',') ?? '';
  return useMemo(() => {
    if (propsSelectedLabels) {
      return propsSelectedLabels;
    }
    return (
      (currentLabelIds &&
        items?.filter((x: Label) => currentLabelIds.includes(x.id))) ||
      []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- labelIdsKey captures id set; same key => same result
  }, [labelIdsKey, items, propsSelectedLabels]);
}
